<app-arcgis-map 
  [activeLayerSelector]="true"
  [editorEnabled]="true"
  [layerList]="layerListSubject"
  [pointsToShow]="pointsToShow"
  [filteredPoints]="filteredPoints"
  [refSubject]=refSubject
></app-arcgis-map>
